import { Flex, Button, ButtonGroup } from '@frontend/components';

import type { AppliedFiltersContainerProps } from '../types';
import AppliedFiltersDisplay from './AppliedFiltersDisplay';

const AppliedFiltersContainer = ({
  filters,
  setFilters,
}: AppliedFiltersContainerProps) => {
  const handleRemoveFilters = () => {
    setFilters({
      ...filters,
      dateMax: undefined,
      dateMin: undefined,
      organizationIds: undefined,
      searchTerm: undefined,
      page: 1,
      dateRange: undefined,
    });
  };

  return (
    <Flex
      border="1px solid"
      borderColor="separator.border"
      justifyContent="space-between"
      borderLeftWidth={5}
      borderLeftColor="interaction.main"
      bg="page.surface"
      px={2}
      py={1.5}
      width="100%"
      marginBottom={3}
    >
      <AppliedFiltersDisplay filters={filters} />
      <ButtonGroup size="md">
        <Button variant="link" onClick={handleRemoveFilters} size="sm">
          Remove filters
        </Button>
      </ButtonGroup>
    </Flex>
  );
};

export default AppliedFiltersContainer;
